<!--
 * @Description:
 * @Author: -898-
 * @Date: 2024-04-23 09:02:35
 * @LastEditTime: 2024-04-24 10:48:13
 * @LastEditors: -898-
-->

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default  {
  name:  'App',
  metaInfo() {
    return {
      title: '',
      titleTemplate: title => {
        return title ? `${title} - ${process.env.VUE_APP_TITLE}` : process.env.VUE_APP_TITLE
      }
    }
  }
}
</script>
<style>
body{
  margin: 0;
  padding: 0;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0!important;
}
.el-tabs__item.is-disabled {
  color: #C0C4CC !important;
}
</style>
